import { DictHandler, SimpleAVHandler, SimpleHandler, SimpleTHandler } from 'src/app/types/@types/sl-v-types';
import { Component, AfterViewChecked, AfterContentInit, ViewChild, ElementRef, Output, EventEmitter, HostBinding } from '@angular/core';
import { TreeComponent, TreeNode, TreeModel, TREE_ACTIONS, ITreeOptions } from '@circlon/angular-tree-component';
import { LayerListProviderService } from 'src/app/services/layer-list-provider.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { LayerPickerDialogService } from '../dialogs/layer-picker-dialog/layer-picker-dialog.service';
import { LayersApiService } from 'src/app/model/api-services/layers-api.service';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { EnvService } from 'src/app/env.service';
import { AccessLevels } from 'src/app/types/access-levels';

@Component({
  selector: 'app-layers-view-v2',
  templateUrl: './layers-view-v2.component.html',
  styleUrls: ['./layers-view-v2.component.scss']
})
export class LayersViewV2Component implements AfterContentInit, AfterViewChecked {
  @ViewChild('tree', { static: true }) tree: TreeComponent;
  name = 'me';
  nodes = [];
  topNodeState = 'closed';
  topNode: any;
  maxHeightPx = 0;
  @HostBinding('style.max-height') maxHeight = '1000rem';
  @HostBinding('class.layers-open') layersOpen = false;
  @HostBinding('class.layers-closed') layersClosed = true;

  @Output() visChange: EventEmitter<any> = new EventEmitter();
  @Output() configClick: EventEmitter<any> = new EventEmitter();
  @Output() viewChange: EventEmitter<any> = new EventEmitter();
  @Output() orderChange: EventEmitter<any> = new EventEmitter();
  public fitHeight = false;
  public collapsed = true;
  // tslint:disable-next-line:variable-name
  public _updated = true;

  // tslint:disable-next-line:variable-name
  private _initCheck = false;
  private map: ISLMap;
  constructor(
    private domNode: ElementRef,
    private layerPickerSvc: LayerPickerDialogService,
    private layerListProvider: LayerListProviderService,
    private layerService: LayerApiService,
    private layersService: LayersApiService,
    private messager: ModalMessagerService,
    private env: EnvService
  ) { }
  public treeOptions = {
    allowDrag: true,
    actionMapping: {
      mouse: {
        drop: (tree: TreeModel, node: TreeNode, $event: any, { from, to }) => {

          if (from.parent.data.id !== to.parent.data.id) {
            return;
          }
          const fromId = from.data.id;
          let toData = 'end';
          if (to.parent.children.length !== to.index) {
            toData = to.parent.children[to.index].data.id;
          }
          // tslint:disable-next-line: object-literal-key-quotes
          this.orderChange.emit({ 'fromId': fromId, toId: toData });
          // use from to get the dragged node.
          // use to.parent and to.index to get the drop location
          // use TREE_ACTIONS.MOVE_NODE to invoke the original action
          TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });
        }
      }
    }
  };
  SetMap(map: ISLMap) {
    this.map = map;
  }
  UpdateHeight(myPanel, maxHeight): boolean {
    const changed = (maxHeight !== 'calc(' + maxHeight + 'px - .75em)');
    this.maxHeight = 'calc(' + maxHeight + 'px - .75em)';
    return changed;
  }
  ngAfterContentInit() {

  }
  DropCheck($event?: any): boolean {
    return false;
  }
  ShowLayers(layers: Array<SLLayer>, ready?: SimpleAVHandler<LayersViewV2Component>) {
    const wasOpen = this.layersOpen;
    this.nodes = this.layerListProvider.GetTreeView(layers, this.tree);
    setTimeout(() => {
      this.topNode = this.tree.treeModel.getNodeById(0);
      if (wasOpen === true) {
        this.topNode.expand();
      }
      this.ToggleTreeVis(wasOpen);
      this.tree.treeModel.getNodeById('results').collapse();
      if (!!ready) {
        ready(this);
      }
    });
  }
  ShowLayer(nodeData) {
    this.configClick.emit({ id: nodeData.id, node: nodeData, view: this });
  }
  ShowSLLayer(layer: SLLayer) {
    const node = this.GetLayerNode(layer.identifier, this.nodes);
    this.ShowLayer(node);
  }
  UpdateLayerVis(layer) {
    const node = this.GetLayerNode(layer.identifier, this.nodes);
    node.visible = layer.layerOn ? '1' : '0';
    this.tree.treeModel.update();
  }
  GetLayerNode(layerId, nodes?: Array<any>): any {
    if (!nodes) nodes = this.nodes;
    for (const node of nodes) {
      if (node.id === layerId) {
        return node;
      }
      if (node.hasOwnProperty('children')) {
        const val = this.GetLayerNode(layerId, node.children);
        if (val !== false) {
          return val;
        }
      }

    }
    return false;
  }
  CanAddLayer(): boolean {
    return this.map.project.access >= AccessLevels.EDIT
  }
  IsHeading(node, index): boolean {
    if (node.data.type) {
      return node.data.type === 'heading';
    }
    return false;
  }
  ToggleVis(node, event) {
    node.data.visible = (event.target.checked === true) ? '1' : '0';
    node.data.layer.layerOn = event.target.checked;
    this.visChange.emit({ id: node.id, isOn: event.target.checked === true });

  }
  HandleLayerRendering(e) {
    $('.layer-' + e.id, this.domNode.nativeElement).toggleClass('fa-spin', true);
  }
  HandleLayerRendered(e) {
    setTimeout(() => {
      $('.layer-' + e.id, this.domNode.nativeElement).toggleClass('fa-spin', false);
    }, 2500);
  }
  HandleViewChange(node: any = null) {
    if (node === null) {
      this.viewChange.emit({ view: this });
    } else if (node.id === 0) {
      this.ToggleTreeVis();
    }
  }
  ngAfterViewChecked() {
    if (!this._initCheck) {
      this.HandleViewChange();
      this._initCheck = true;
      this.ToggleTreeVis(false);
    }
  }
  HandleToggle() {
    setTimeout(() => { this._updated = false; });
    setTimeout(() => { this._updated = true; });
  }
  UpdateCheck(className: string, node) {
    $(className, this.domNode.nativeElement).prop('checked', node.data.visible === '1');
  }
  RemoveAllLayers() {
    this.ShowLayers([]);
    this.SetHeight();

  }
  ToggleTreeVis(onOrOff: boolean | null = null) {

    this.layersOpen = (onOrOff === null) ? !this.layersOpen : onOrOff;
    this.layersClosed = !this.layersOpen;
    this.SetHeight();
    this.visChange.emit({ id: -1, isOn: this.layersOpen });
    this.HandleToggle();


  }
  private SetHeight() {
    this.fitHeight = this.layersOpen;
    this.collapsed = this.layersClosed;
    // this.domNode.nativeElement.style.height = this.layersOpen ? 'fit-content' : '2.5em';
  }
  AddLayer() {
    this.layerPickerSvc.Show((layer: SLLayer) => {
      this.messager.Progress('Requesting server add layer to map', false, 33, 'Adding Layer');
      this.layersService.AddLayerToProject(this.map.project.id, layer.id).then((message) => {
        this.messager.Progress('Server added layer to map, adding layer locally', false, 66, 'Adding Layer');
        const index = this.map.project.layers.length;
        this.map.project.layers.push(message.response.projectLayer);
        const slLayer = this.map.AddLayerFromProject(index);
        slLayer.SetLayerOn(true, this.map);
        this.messager.Progress('Layer added.', false, 100, 'Adding Layer');
        this.ShowLayers(this.map.layers, () => {
          this.map.UpdateLayerOrder();
        });

        slLayer.Render();
      });
    });
  }
  Refresh() {
    if (!this.map) {
      return;
    }
    this.nodes = this.layerListProvider.GetTreeView(this.map.layers, this.tree);
  }
  HandleExtras(params: any) {
    if (params.ppanelExpanded) {
      this.layersOpen = params.ppanelExpanded;
      this.Expand(this.layersOpen);
    }
  }
  ToggleExpanded(expanded?:boolean) {
    if(expanded === undefined) expanded = !this.layersOpen;
    this.Expand(expanded);
  }
  Expand(isExpanded: boolean = true) {

    this.layersOpen = isExpanded;
    if (this.layersOpen === true) {
      this.tree.treeModel.getNodeById(0).expand();
    } else {
      this.tree.treeModel.getNodeById(0).collapse();
    }
  }

  GetNode(id): any {
    return this.tree.treeModel.getNodeById(id);
  }
  IsRaster(node: any): boolean {
    if (!node.data.layer) return false;
    return (node.data.layer as SLLayer).isRaster;
  }
  IsWMS(node: any): boolean {
    if (!node.data.layer) return false;
    return (node.data.layer as SLLayer).isWMS;
  }

  IsVisibleHeading(node: any) {
    if (node.data.id === 'results') {
      return true;
      return node.data.layer.hasResults;
    }
    if(node.parent?.data.id === 'results') {
      return node.parent?.data.layer.hasMoment;
    }
    return node.data.enabled;
  }

}
